import React from 'react';
import SouthIcon from '@mui/icons-material/South';
import EastIcon from '@mui/icons-material/East';
import AlignHorizontalCenterIcon from '@mui/icons-material/AlignHorizontalCenter';
import AlignHorizontalLeftIcon from '@mui/icons-material/AlignHorizontalLeft';
import AlignHorizontalRightIcon from '@mui/icons-material/AlignHorizontalRight';
import AlignVerticalBottomIcon from '@mui/icons-material/AlignVerticalBottom';
import AlignVerticalCenterIcon from '@mui/icons-material/AlignVerticalCenter';
import AlignVerticalTopIcon from '@mui/icons-material/AlignVerticalTop';
import ManualSpacingIcon from './icons/ManualSpacingIcon';
import AutoSpacingIcon from './icons/AutoSpacingIcon';

export const paddingOptions = [
	'0',
	'1',
	'2',
	'3',
	'4',
	'5',
	'6',
	'8',
	'10',
	'12',
	'16',
	'20',
	'24',
	'32',
	'40',
	'48',
	'56',
	'64'
];

export const shadowOptions = ['', 'md', 'lg', 'xl', '2xl'];

export const borderRadiusOptions = ['', 'sm', 'md', 'lg', 'xl', '2xl', '3xl'];

// eslint-disable-next-line prefer-spread, @typescript-eslint/no-unused-vars
export const widthOptions = Array.apply(null, Array(100)).map(
	(_, i) => `${i + 1}`
);

export const directionOptions = [
	{ value: 'col', label: <SouthIcon /> },
	{ value: 'row', label: <EastIcon /> }
];

export const verticalAlignmentOptions = [
	{ value: 'start', label: <AlignVerticalTopIcon /> },
	{ value: 'center', label: <AlignVerticalCenterIcon /> },
	{ value: 'end', label: <AlignVerticalBottomIcon /> }
];

export const horizontalAlignmentOptions = [
	{ value: 'start', label: <AlignHorizontalLeftIcon /> },
	{ value: 'center', label: <AlignHorizontalCenterIcon /> },
	{ value: 'end', label: <AlignHorizontalRightIcon /> }
];

export const spacingTypeOptions = [
	{ value: 'manual', label: <ManualSpacingIcon /> },
	{ value: 'between', label: <AutoSpacingIcon /> }
];

export const spaceBetweenOptions = [
	'0',
	'0.5',
	'1',
	'1.5',
	'2',
	'2.5',
	'3',
	'3.5',
	'4',
	'5',
	'6',
	'7',
	'8',
	'9',
	'10',
	'11',
	'12',
	'14',
	'16',
	'20',
	'24',
	'28',
	'32'
];
